import React from "react";
import Message from "../FormField/Message";
import { SimpleFieldProps } from "../types";
import classNames from "classnames";
import FormField from "../FormField";
import useDefaultValueAs from "@/hooks/useDefaultValueAs";
import "./styles.scss";

export const AlertBox = ({
  t,
  field,
  register,
  touchedFields,
  isSubmitted,
  errors,
  className: classNameProp,
  values,
  setValue,
}: SimpleFieldProps) => {
  const inputID = field.id || field.name;
  const className = classNames(`alertBox`, {
    [field.class as string]: typeof field.class === "string" && field.class.length > 0,
    [classNameProp as string]: classNameProp,
  });

  const hasNotEmptyValue = values?.[field.name] && values?.[field.name].length > 0;
  const validate = !errors[field.name]; // If there are no errors, validation is successful
  const validField =
    (touchedFields?.[field?.name] && !errors[field.name] && hasNotEmptyValue) || false; // Field is valid if no errors and has a value
  const shouldShowError =
    errors && errors[field.name] && (touchedFields?.[field.name] || isSubmitted);

  useDefaultValueAs({ field: field, setValue: setValue, values: values });

  return (
    <>
      <FormField
        id={inputID}
        name={field.name}
        className={className}
        helperMessage={
          (field.helperMessage && t[field.helperMessage]) || (field.help && t[field.help])
        }
        errorMessage={shouldShowError ? t[errors[field.name]?.message as string] : undefined}
        disclaimerAfterField={field.disclaimer && t[field.disclaimer]}
        disclaimerAlert={field.disclaimerAlert && t[field.disclaimerAlert]}
        tooltip={field.tooltip && t[field.tooltip]}
        validate={validate}
        validField={validField}>
        <Message
          type="disclaimerAlert"
          content={t[field.label] || field.label}
        />
      </FormField>
    </>
  );
};
